import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03154d14"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogCategories: require('/vercel/path0/components/blogCategories.vue').default,BlogPost: require('/vercel/path0/components/blogPost.vue').default,Intermission: require('/vercel/path0/components/intermission.vue').default,LoadMore: require('/vercel/path0/components/ui/loadMore.vue').default})
